import React, { useState } from 'react'
import { MDBAnimation, MDBBtn, MDBIcon, MDBTooltip } from 'mdbreact'
import { withRouter } from 'react-router-dom';

const SearchModal = ({show, history, onClick}) => {
    const [search, setSearch] = useState('');
    
    const onChange = e => setSearch(e.target.value)
    const onSubmit = e => {
        e.preventDefault();
        history.push(`/search/${search}`)
    }

    return (
        <>
        <div style={{ display: show ? "inline" : "none" }} className="search-wrapper">
            <MDBAnimation type="slideInUp">
                <>
                    <form onSubmit={(e)=>onSubmit(e)}>
                        <div className="d-none d-md-inline d-lg-inline">
                            <div className="d-flex">
                                <div>
                                    <input required name="search" value={search} onChange={(e)=>onChange(e)} type="text" placeholder="Find blogs, keywords: Title, Content, Category. Ex: 'Two and a half men'" style={{ borderRadius: 0, border: `1px solid #000`, width: 700 }} className="form-control form-control-lg" />
                                </div>
                                <div>
                                    <MDBBtn type="submit" color="dark" className="text-capitalize m-0 mx-4">
                                        Search
                                    </MDBBtn>
                                </div>
                                <MDBTooltip domElement tag="div" placement="bottom">
                                <div onClick={onClick} className="align-self-center cursor-pointer-style">
                                    <MDBIcon far size="lg" icon="times-circle" />
                                </div>
                                <div>Close Search</div>
                                </MDBTooltip>
                            </div>
                        </div>
                        <div className="d-md-none d-lg-none d-inline">
                            <div className="d-flex">
                                <div>
                                    <input required name="search" value={search} onChange={(e)=>onChange(e)} type="text" placeholder="Find blogs, Ex: 'Two & a half'" style={{ borderRadius: 0, border: `1px solid #000`, width: 300 }} className="form-control form-control-lg" />
                                </div>
                                <div className="align-self-center">
                                    <button style={{ background: `transparent`, border: 0 }} type="submit">
                                        <MDBIcon className="cursor-pointer-style mx-2" size="2x" icon="search"/>
                                    </button>
                                </div>
                                <div onClick={onClick} className="align-self-center cursor-pointer-style">
                                    <MDBIcon far size="lg" icon="times-circle" />
                                </div>
                            </div>
                        </div>
                    </form>
                </>
            </MDBAnimation>
        </div>
        </>
    )
}

export default withRouter(SearchModal)
